
















import { Vue, Component } from 'vue-property-decorator';
import router from '../router';
import { MedTransGoConstants } from '../util/constants';
import DataTable from '../components/DataTable.vue';
import { ObjectFactory } from '@/config/objectFactory';
import { DateUtils } from '@/util/dateUtils';
import { CommonUtils } from '@/util/commonUtils';
import { MemberProfile } from '@/types/response';

// tslint:disable-next-line: no-var-requires
const ApiKeyTable = require('../datatable/APIKeyTable.json');
@Component({
    methods: {
        goBack() {
            router.back();
        },
    },
    components: {
        DataTable,
    },
    watch: {
        $route(to, from) {
            if (!to.path.endsWith(MedTransGoConstants.URL_ADD_ACCESS_KEY)) {
                const accessKeyListComponent = this as AccessKeyList;
                accessKeyListComponent.getAccessKeyList();
            }
        },
    },
    data() {
        return {
            header: 'API Integration',
            options: [
                {
                    url: 'access-keys',
                    activeConditions: {
                        lastletters: 'access-keys',
                    },
                    label: 'Access Key',
                },
            ],
        };
    },
})
export default class AccessKeyList extends Vue {
    private apiKeyTableDataSource = ApiKeyTable;
    private showLimiEexceeded = false;
    private accessKeys: MemberProfile[] = [];

    public async mounted() {
        this.getAccessKeyList();
    }

    private showAddAPIKeys() {
        if (this.accessKeys && this.accessKeys.length > 0) {
            this.showLimiEexceeded = true;
        } else {
            this.$router.push({ path: MedTransGoConstants.URL_ADD_ACCESS_KEY, append: true });
        }
    }
    private async getAccessKeyList(searchString?: string, start?: number) {
        const response = await ObjectFactory.getMemberService().getAccessKeyList(this.$store.state.serverUrl, start);
        if (response.success && response.data) {
            response.data.forEach((accessKey) => {
                accessKey.addedOn = DateUtils.formatDate(accessKey.addedOn) as any;
            });
            this.accessKeys = response.data;
            this.apiKeyTableDataSource.data = response.data;
            if (response.totalCount) {
                this.apiKeyTableDataSource.totalCount = response.totalCount;
            } else {
                CommonUtils.showError(response);
            }
        }
    }
}
